export enum InventoryCostPool {
  LOCATION = "LOCATION",
  STORE = "STORE",
}
